import { Box, styled, Typography } from "@mui/material";
import useSettings from "app/hooks/useSettings";

// STYLED COMPONENTS
const BrandRoot = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "20px 18px 20px 20px",
}));

const LogoMark = styled(Box)(({ mode }) => ({
  width: 36,
  height: 36,
  borderRadius: 10,
  background: "linear-gradient(135deg, #667eea, #764ba2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  boxShadow: "0 4px 12px rgba(102,126,234,0.4)",
}));

const BrandName = styled(Typography)(({ mode }) => ({
  fontSize: 15,
  fontWeight: 700,
  marginLeft: "10px",
  letterSpacing: 0.3,
  whiteSpace: "nowrap",
  display: mode === "compact" ? "none" : "block",
  background: "linear-gradient(90deg, #fff, rgba(255,255,255,0.75))",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}));

export default function Brand({ children }) {
  const { settings } = useSettings();
  const leftSidebar = settings.layout1Settings.leftSidebar;
  const { mode } = leftSidebar;

  return (
    <BrandRoot>
      <Box display="flex" alignItems="center">
        <LogoMark mode={mode}>
          {/* Simple "D" monogram */}
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 800,
              fontSize: 16,
              lineHeight: 1,
              fontFamily: "'Inter', sans-serif",
            }}
          >
            D
          </Typography>
        </LogoMark>
        <BrandName mode={mode} className="sidenavHoverShow">
          Dahiya Insurance
        </BrandName>
      </Box>

      <Box
        className="sidenavHoverShow"
        sx={{ display: mode === "compact" ? "none" : "block" }}
      >
        {children || null}
      </Box>
    </BrandRoot>
  );
}
